import Marquee from "react-fast-marquee";

const ITEMS = [
  "BP & Vitals",
  "A Live Call Home",
  "Medicine Support",
  "Emergency Response",
  "Weekly Meetups",
  "Hospital Visits",
  "With Your Consent",
];

export const EditorialMarquee = () => (
  <section
    data-testid="marquee"
    className="bg-brand-sand border-y border-border py-8"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((it, i) => (
        <div key={i} className="flex items-center gap-24 pr-24">
          <span className="font-serif italic text-3xl sm:text-4xl text-brand-ink/80">
            {it}
          </span>
          <span className="h-2 w-2 rounded-full bg-brand" />
        </div>
      ))}
    </Marquee>
  </section>
);
